import angular = require('angular');
import { IModalServiceInstance } from 'angular-ui-bootstrap';
import { ProductsService } from '../../products.service';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { PopupService } from '../../../../../app.common/modules/common/services/popup.service';
import { PopupServiceCancel } from '../../../../../app.common/modules/common/models/popupServiceCancel';


class ProductsImportModalInstance {
    static $inject = ['$q', '$timeout', 'productsService', 'popupService', 'notificationService', '$translate'];
    waiting = false;
    isCategoriesMappingExist = false;
    isQueuedProductsExist = false;
    importType = this.productsService.importType;
    importImpossibleTooltip: string;
    private inputFile: JQuery;
    private modalInstance: IModalServiceInstance = <any>this;


    constructor(
        private $q: ng.IQService,
        private $timeout: ng.ITimeoutService,
        private productsService: ProductsService,
        private popupService: PopupService,
        private notificationService: NotificationService,
        private $translate: angular.translate.ITranslateService
    ) {
        this.isPossibleImport();
    }

    $onInit() {
        this.inputFile = angular.element('#fileInput');
        this.inputFile.on('change', this.changeFileInputup);
    }

    openFile(type: number) {
        if (this.inputFile && this.inputFile.data) {
            let key = 'type';
            this.inputFile.data[key] = type;
            this.$timeout(() => { this.inputFile.click(); });
        }
    }

    cancel() {
        this.modalInstance.dismiss({ $value: 'cancel' });
    }

    save() {
        this.modalInstance.close({ $value: '' });
    }

    impossibleImportProduct() {
        if (!this.isCategoriesMappingExist) {
            this.importImpossibleTooltip = this.$translate.instant('must_import_mapping_of_categories');
        } else if (this.isQueuedProductsExist) {
            this.importImpossibleTooltip = this.$translate.instant('import_is_not_possible');
        } else {
            this.importImpossibleTooltip = null;
        }

        return this.importImpossibleTooltip != null;
    }

    private changeFileInputup = async (e: JQueryEventObject) => {
        let element = <HTMLInputElement>e.target;

        let file: File = element.files[0];
        if (!file) {
            return;
        }

        let key = 'type';
        let type = $(element).data[key];
        this.waiting = true;
        this.notificationService.showWaitingMessage();

        try {
            let report = await this.productsService.uploadImportFile(file, type);
            this.notificationService.clearAll();
            let line = report.split('\n').length;
            await this.popupService.alert({
                title: this.$translate.instant(type === this.importType.category ? 'import_external_categories_result' : 'import_products_result'),
                content: `<div ${line > 4 ? 'style="height: 150px;overflow: auto"' : ''}><pre>${report}</pre></div>`
            });

            this.isPossibleImport();
        } catch (error) {
            if (!PopupServiceCancel.isCancelOrBackdropClickInstance(error)) {
                this.notificationService.showErrorMessage(error);
            }
        }
        element.value = null;
    }

    private isPossibleImport = async () => {

        this.waiting = true;
        this.notificationService.showWaitingMessage();
        try {
            let result = await this.$q.all([this.productsService.isExistCategoryMapping(), this.productsService.isProductsImportQueued()]);
            this.isCategoriesMappingExist = result[0];
            this.isQueuedProductsExist = result[1];
            this.notificationService.clearAll();
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;
    }
}


angular.module('naut')
    .component('productsImport', {
        template: require('./productsImport.html'),
        controller: ProductsImportModalInstance,
        controllerAs: 'vm',
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/products/components/productsImport/productsImport.component.ts